import Vue from "vue";

const success = (context, response) => {
  context.uploadedFileFile = response.file;
  context.uploadedFilePath = response.path;

  if (response.path && response.path) {
    context.formItem.redirect_file = response.path;
    context.loadingFile = false;
    context.fileUploaded = true;
    context.uploadedFilepath = response.path;
    toastr.success(context.$t("rentals.detail.file_upload_success"));
  }
};

const failed = (context, error) => {
  context.loadingFile = false;
  if (error.response) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.msg &&
      typeof error.response.data.msg == "object"
    ) {
      for (var key in error.response.data.msg) {
        if (error.response.data.msg.hasOwnProperty(key)) {
          toastr.error(error.response.data.msg[key]);
        }
      }
    } else {
      toastr.error(error.response.data.msg);
    }
  }
};

export default (context, formData) => {
  return Vue.$http
    .post("/files/upload-file", formData)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data);
      }
    })
    .catch((error) => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/file/uploadFile.js